import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Apiurl from "../../Helpers/apiUrl";
import Swal from "sweetalert2";
import { fetchMasterProduct } from "../../redux/slices/productSlice";
import { useDispatch } from "react-redux";

const AdminLogin = ({ children }) => {
    const navigate = useNavigate();
    const [data, setData] = useState();
    const dispatch = useDispatch();

    const hasToken = localStorage.getItem("u_token");

    useEffect(() => {
        Login();
        dispatch(fetchMasterProduct());

    }, []);

    const Login = async () => {
        try {
            const user = localStorage.getItem("u_token");
            if (!user) {
                handleLogout();
                return;
            }

            const headers = {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + user,
            };

            const response = await axios.get(`${Apiurl}profile`, { headers });

            if ((response.status) && (response.data.data.role_id == 1) && response.data.data.is_active == 1) {
                setData(response.status);
            } else {
                handleLogout();
            }
        } catch (error) {
            const isUnauthorized = error.response && error.response.status === 401;
            const isNetworkError = !error.response;

            if (isUnauthorized) {
                handleLogout("Session Expired", "Your session is invalid or has expired.");
            } else if (!isNetworkError) {
                console.error("Login API Error:", error);
                handleLogout("Error", "An unexpected error occurred. Redirecting to login.");
            }
        }
    };

    const handleLogout = (title, text) => {
        localStorage.removeItem("u_token");
        localStorage.removeItem("role_code");
        if (title) {
            Swal.fire({ icon: "error", title, text });
        }
        navigate('/admin/login');
    };

    if (hasToken) {
        return children;
    } else {
        navigate('/admin/login');
        return null;
    }
}

export default AdminLogin;